import EventEmitter from "eventemitter3";

import { default as React } from "react";
import { MODAL_HIDE, MODAL_SHOW, ModalComponent, ModalComponentProps } from "./ModalTypes";

const eventEmitter = new EventEmitter();

/**
 * Zobrazení modálního dialogu. Pokud je nějaký dialog zobrazen, zobrazí se nad ním další.
 *
 * @param component reference na komponentu
 * @param componentProps props, které budou předávány při renderování komponenty
 *
 * @returns {{type: string, component: *, componentProps: *}}
 */
export function show(component: ModalComponent, componentProps?: ModalComponentProps) {
    eventEmitter.emit(MODAL_SHOW, {
        component,
        componentProps,
    });
}

export function showWaiting<T>(
    waitingPromise: Promise<T>,
    component: ModalComponent,
    componentProps?: ModalComponentProps,
): Promise<T> {
    return new Promise(function (resolve, reject) {
        show(props => {
            waitingPromise
                .then(data => {
                    props.onClose();
                    // @ts-ignore
                    resolve(data);
                })
                .catch(error => {
                    props.onClose();
                    reject(error);
                });
            return React.createElement(component, {
                ...props,
            });
        }, componentProps);
    });
}

/**
 * Zavření aktuálního dialogu. Pokud je jich otevřeno více, zavře se poslední otevřený.
 *
 * @returns {function(*, *)}
 */
export function hide() {
    eventEmitter.emit(MODAL_HIDE, {});
}

export default eventEmitter;
